import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  FormDatepickerComponent,
} from '@fitness-force/shared';
import { Store } from '@ngrx/store';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { COMPANY_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { BehaviorSubject, Observable } from 'rxjs';

import { ErrorMsgComponent } from '@fitness-force/errors';
import { MultiSelectModule } from 'primeng/multiselect';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TimeconversionService } from '@fitness-force/api';
import { DatePickerModule } from 'primeng/datepicker';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    SelectModule,
    ErrorMsgComponent,
    FormDatepickerComponent,
    TranslateModule,
    MultiSelectModule,
    ToggleSwitchModule,
    DatePickerModule,
    MessageModule
  ]
})
export class DynamicFormComponent implements OnInit {
  @Input() field!: any;
  @Input() form!: UntypedFormGroup;
  @Input() selectedRelativeDate: Observable<any> | any;
  @Input('CustomDates') timePeriod: Observable<any> | any;

  @Output() selectedTimePeriodOutput: EventEmitter<any> = new EventEmitter();
  @Output() timePeriodObjectOutput: EventEmitter<any> = new EventEmitter();
  @Output() moreThan3monthOutput: EventEmitter<any> = new EventEmitter();
  @Output() FormOutput: EventEmitter<UntypedFormGroup> = new EventEmitter();

  public companyInfoDetail$!: Observable<any>;
  selectedTimePeriod: Observable<any> | any;
  timePeriodDate: Observable<Date[]> | any;
  customDateModal = new BehaviorSubject(false);
  moreThanThreeMonths = false;
  selectedFormGroup: any;
  reportLongerThan3Months = false;
  shoCustomDateRange = false;

  constructor(private translate: TranslateService, private store: Store, private timeService: TimeconversionService, public cdr :ChangeDetectorRef) { }

  ngOnInit(): void {
    if (this.selectedRelativeDate) {
      this.form.get('timePeriod')?.setValue(this.selectedRelativeDate);
      this.selectedTimePeriod = this.selectedRelativeDate;
      if (this.selectedTimePeriod.value == 99) {
        this.shoCustomDateRange = true;
      }
    }
    this.timePeriodDate = this.timePeriod;
    this.form.updateValueAndValidity();
    this.cdr.detectChanges();
    this.componentInit();
  }

  componentInit() {
    this.companyInfoDetail$ = this.store.select(COMPANY_INFO);
    this.companyInfoDetail$.subscribe((responseData) => {
      this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
      this.translate.use(responseData?.selectedLang?.LANG_CODE);
    });
  }

  SelectTimePeriod(timePeriod: any, form: any) {
    this.selectedTimePeriod = timePeriod.value;
    let startDate: Date = new Date();
    let endDate: Date = new Date();

    if (timePeriod.value.value == 99) {
      this.customDateModal.next(true);
    } else {
      startDate = new Date(this.selectedTimePeriod.date['from_date']);
      endDate = new Date(this.selectedTimePeriod.date['to_date']);
      this.moreThanThreeMonths = false;
      this.timePeriodDate = null;
    }
    form.get('to_date').setValue(endDate);
    form.get('from_date').setValue(startDate);
    this.selectedTimePeriodOutput.emit({
      timePeriod: this.selectedTimePeriod,
      form: form,
    });
  }

  onDateSelect(event: any, form: any) {
    this.customDateModal.next(false);
    this.timePeriodDate = event.dateObject;
    const months = this.monthDiff(
      this.timePeriodDate[0],
      this.timePeriodDate[1]
    );

    if (months >= 3) this.moreThanThreeMonths = true;
    else this.moreThanThreeMonths = false;

    this.selectedFormGroup = event.form;
    event.form.get('from_date').setValue(this.timePeriodDate[0].toISOString());
    event.form.get('to_date').setValue(this.timeService.getEndOfDay(this.timePeriodDate[1]).toISOString());
    this.selectedTimePeriodOutput.emit({
      timePeriod: this.selectedTimePeriod,
      form: form,
    });
    this.timePeriodObjectOutput.emit({
      dateObject: this.timePeriodDate,
      disableButton: this.moreThanThreeMonths,
    });
  }

  OpenLongerReport() {
    this.moreThan3monthOutput.emit({ status: true, form: this.form });
  }

  monthDiff(d1: Date, d2: Date): number {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  }

  hideCalender(e: any) {
    this.customDateModal.next(false);
    this.selectedTimePeriod = null;
    this.selectedRelativeDate = null;
    this.timePeriodDate = null;
    this.form.get('timePeriod')?.setValue(null);
  }

  getAriaLabel(label: string, controlType: string): string {
    const translatedLabel = this.translate.instant(label);
    return `${translatedLabel.toLowerCase().replace(/\s+/g, '-')}-${controlType}`;
  }

  get GetTimeObject(): Date[] {
    return this.timePeriodDate;
  }

  get GetselectedTimePeriod() {
    return this.selectedTimePeriod;
  }

  GetField(form: UntypedFormGroup, field: any): UntypedFormControl {
    return this.form.controls[field] as UntypedFormControl;
  }
  GetFieldValue(form: UntypedFormGroup, field: any) {
    return this.form.get(field)?.value;
  }
}
